import React, { useRef, useState } from 'react';
import { ChevronLeft, ChevronRight, ArrowUpRight } from 'lucide-react';

const CardSlider = ({ eyebrow, title, subtitle, items, cardVariant = 'default' }) => {
  const scrollerRef = useRef(null);
  const [page, setPage] = useState(0);

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const w = el.clientWidth * 0.85;
    el.scrollBy({ left: dir * w, behavior: 'smooth' });
    setTimeout(() => {
      const p = Math.round(el.scrollLeft / (el.clientWidth * 0.85));
      setPage(p);
    }, 400);
  };

  return (
    <section className="py-20 bg-[#f7f8f4]">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            {eyebrow && (
              <span className="inline-block text-[#8ec045] text-xs font-bold tracking-[4px] mb-3">
                {eyebrow}
              </span>
            )}
            <h2
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {title}
            </h2>
            {subtitle && <p className="mt-3 text-[#666] max-w-xl">{subtitle}</p>}
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scroll(-1)}
              className="w-11 h-11 rounded-full border border-[#d3d9c8] bg-white hover:bg-[#8ec045] hover:border-[#8ec045] hover:text-white text-[#5a6b3a] flex items-center justify-center transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={() => scroll(1)}
              className="w-11 h-11 rounded-full border border-[#d3d9c8] bg-white hover:bg-[#8ec045] hover:border-[#8ec045] hover:text-white text-[#5a6b3a] flex items-center justify-center transition-colors"
              aria-label="Next"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Slider */}
        <div
          ref={scrollerRef}
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 no-scrollbar"
          style={{ scrollbarWidth: 'none' }}
        >
          {items.map((item) => (
            <article
              key={item.id}
              className="snap-start shrink-0 w-[85%] sm:w-[45%] lg:w-[31%] group cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[4/3] mb-4 bg-gray-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                {item.date && (
                  <span className="absolute top-4 left-4 bg-[#8ec045] text-white text-[10px] font-bold px-3 py-1 tracking-wider">
                    {item.date}
                  </span>
                )}
                <div className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-white/95 flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
                  <ArrowUpRight className="w-4 h-4 text-[#2d4a1a]" />
                </div>
              </div>
              <h3 className="text-[17px] leading-snug font-semibold text-[#1a1a1a] group-hover:text-[#8ec045] transition-colors line-clamp-3">
                {item.title}
              </h3>
              <div className="mt-3 flex items-center gap-2 text-[#8ec045] text-[12px] font-bold tracking-wider">
                READ MORE <ArrowUpRight className="w-3.5 h-3.5" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardSlider;
